import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useFinanceService } from '../../../../apis/finance/useFinanceService';
import {
  TFinancialGrantResponse,
  GrantListParams,
} from '../../../../apis/finance/financialGrants.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getFinancialGrantsKey = 'get-financial-grants';

export const useFinancialGrantsHook = (
  params: GrantListParams,
  options?: UseQueryOptions<TFinancialGrantResponse, TQueryError>
): UseQueryResult<TFinancialGrantResponse, TQueryError> => {
  const { getGrantList } = useFinanceService();

  return useQuery<TFinancialGrantResponse, TQueryError>({
    queryKey: [getFinancialGrantsKey, params],
    queryFn: () => getGrantList(params),
    enabled: true,
    ...options,
  });
};

